import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../reportv2.const';
import { ReportService } from '../../../../../common/services/Report.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
import { Role } from '../../setting/expert/agent/agent.const';

declare var require: any;
const moment = require('moment');
const HighchartsExporting = require('highcharts/modules/exporting');
declare var $: any;
@Component({
  selector: 'report-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
  providers: [ReportService, ExportCustomService],
})
export class SummaryComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public backgroundList = ['#fee4cb', '#e9e7fd', '#dbf6fd', '#ffd3e2', '#c8f7dc'];

  public Roles = Role;

  public optionsSourceNameList = {
    doing: 'Đang xử lý',
    close: 'Đã đóng',
    solved: 'Đã giải quyết',
    open: 'Mở',
    call_report: 'Cuộc gọi đã trả lời',
    ticket_report: 'Báo cáo ticket',
    all: 'Tất cả',
  };

  public exportType = {
    SourceTicket: 'SourceTicket',
    Customer: 'Customer',
    BestAgents: 'BestAgents',
    Effort: 'Effort',
    Groups: 'Groups',
  };

  public colorsOptionsSourceName = [
    '#099516',
    '#ffd061',
    '#05027c',
    '#096c86',
    '#706f6f',
    '#c5c7cd',
    '#a2ecff',
    '#ffd9d9',
    '#ff4240',
    '#000000',
  ];
  public lengedOptionsSourceName = [];

  public sourceKeys = [
    { key: 'CALL_OUTBOUND', label: 'Gọi điện ra' },
    { key: 'CALL_INBOUND', label: 'Khách gọi tới' },
    { key: 'zalo', label: 'Kênh Zalo' },
    { key: 'hand', label: 'Manually' },
    { key: 'facebook', label: 'Kênh Facebook' },
    { key: 'sms', label: 'SMS' },
    { key: 'chat', label: 'Kênh Chat' },
    { key: 'email', label: 'Kênh Email' },
    { key: 'import', label: 'Import' },
    { key: 'CALL_INTERNAL', label: 'Call_internal' },
  ];
  public dataSummary: any = null;
  public optionsSourceData: any = {};
  public optionsCustomer: any = {};
  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportCustomService: ExportCustomService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    HighchartsExporting(Highcharts);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.initData().then((data) => {})
  }

  ngAfterViewInit(): void {}
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/summary/summary.component.ts